import classNames from 'classnames'
import { JSX } from 'react'
import { useTranslation } from 'react-i18next'

import { webApp } from '@shared'
import { InventoryMode } from '@store'

import styles from './InventoryTabs.module.scss'

interface InventoryTabsProps {
  mode?: InventoryMode
  tabIndex: number
  questsAmount: number
  skinsAmount: number
  itemsAmount: number
  onChange(index: number): void
  onClose(): void
}

export const InventoryTabs = ({
  mode = 'fullscreen',
  tabIndex,
  questsAmount,
  skinsAmount,
  itemsAmount,
  onChange,
  onClose,
}: InventoryTabsProps): JSX.Element => {
  const { t } = useTranslation()
  const handleClick = (index: 0 | 1 | 2) => {
    webApp.HapticFeedback.impactOccurred('soft')
    onChange(index)
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <div
      className={classNames(
        styles.inventoryTabs,
        mode === 'minimized' && styles.isMinimized
      )}
    >
      <div
        className={classNames(styles.tab, tabIndex === 0 && styles.isActive)}
        onClick={() => handleClick(0)}
      >
        {t('shared.inventory.tabs.items')}
        <div className={styles.counter}>{questsAmount}</div>
      </div>
      <div className={styles.separator} />
      <div
        className={classNames(styles.tab, tabIndex === 1 && styles.isActive)}
        onClick={() => handleClick(1)}
      >
        {t('shared.inventory.tabs.notes')}
        <div className={styles.counter}>{skinsAmount}</div>
      </div>
      <div className={styles.separator} />
      <div
        className={classNames(styles.tab, tabIndex === 2 && styles.isActive)}
        onClick={() => handleClick(2)}
      >
        {t('shared.inventory.tabs.boosters')}
        <div className={styles.counter}>{itemsAmount}</div>
      </div>
      {mode === 'minimized' ? (
        <div className={styles.cross} onClick={handleClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <line
              x1="5.94999"
              y1="7.03078"
              x2="17.9708"
              y2="19.0516"
              stroke="white"
            />
            <line
              x1="17.9707"
              y1="6.81327"
              x2="5.94992"
              y2="18.8341"
              stroke="white"
            />
          </svg>
        </div>
      ) : null}
    </div>
  )
}
